import { render } from "./ButtonWithIcon.vue?vue&type=template&id=766cc85a&scoped=true"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=766cc85a&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766cc85a"]])

export default __exports__